<template>
  <div
    v-if="invitation"
    class="is-border vadTask has-background-white">
    <div class="vadTask-hover"></div>
    <div
      class="is-padding-left is-padding-right is-padding-top-small is-padding-bottom-small"
      style="flex: 1 0 auto;">
      <!-- HB : "style="flex: 1 0 auto;" Utile lorsque les cards doivent avoir la même hauteur -->
      <div class="columns">
        <div class="column is-narrow">
          <avatar
            :use-picto-custom="avatar.icon"
            :force-picto="true"
            :is-avatar="false"
            :item="{}"
            class="is-medium has-text-white is-margin-top-xsmall"
            :class="avatar.background">
          </avatar>
        </div>
        <div class="column">
          <p
            v-if="'last_login_at' in invitation && invitation.last_login_at"
            class="is-size-7 has-text-weight-light has-text-grey is-margin-bottom-xxsmall">
            <span>Connecté {{ invitation.last_login_at | timeDelta }}</span>
          </p>
          <p
            v-if="'first_admin' in invitation && invitation.first_admin"
            class="is-size-4 has-text-weight-light">
            <span>{{ invitation.first_admin.last_name }} {{ invitation.first_admin.first_name }}</span>
          </p>
          <p
            v-else
            class="is-size-4 has-text-weight-light">
            <span>{{ invitation.name }}</span>
          </p>
          <p class="is-size-4 is-margin-bottom-xxsmall">
            <span>
              <span>Société : {{ invitation.name }}</span>
            </span>
          </p>
          <div class="columns is-multiline">
            <div class="column is-narrow">
              <span class="has-text-grey is-size-6">{{ invitation.email }}</span>
            </div>
            <div
              v-if="'access' in invitation && invitation.access"
              class="column is-narrow">
              <span class="has-text-grey is-size-6">Mandat(s) proposé(s) ({{ invitation.access }})</span>
            </div>
            <div
              v-if="invitation.status !== 'refused'"
              class="column is-narrow">
              <span class="is-size-6">Invitation lancée le {{ invitation.created_on | date }}</span>
            </div>
            <div
              class="column is-narrow"
              v-if="'message' in invitation && invitation.message">
              <a
                @click="showMessage(invitation.message)"
                class="is-underline is-size-6">Voir le message</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
      mode="out-in">
      <div
        v-if="isPromoteur"
        key="buttons"
        class="veryFastAnimation is-paddingless-top is-paddingless-bottom vadTask-footer columns is-gapless"
        :class="{'is-border-top is-border--dashed': ['pending', 'invitation'].includes(invitation.status)}">
        <div class="column is-narrow-widescreen">
          <button
            v-if="invitation.status === 'pending'"
            class="button is-fullwidth is-white is-small is-radiusless is-size-7"
            :disabled="cardLoading"
            @click="canceledInvitation">
            <span class="icon is-small"><i class="fas fa-stop-circle"></i></span>
            <span class="is-uppercase">Annuler l'invitation</span>
          </button>
        </div>
        <div class="column is-narrow-widescreen">
          <router-link
            tag="button"
            :to="{name: 'NewInvitation', params: {id: invitation.pk, type: invitation.type}}"
            class="button is-fullwidth is-white is-small is-radiusless is-size-7"
            :disabled="cardLoading">
            <span class="icon is-small"><i class="fas fa-paper-plane"></i></span>
            <span class="is-uppercase">Relancer invitation</span>
          </router-link>
        </div>
      </div>
      <div
        v-else
        key="buttons"
        class="veryFastAnimation is-paddingless-top is-paddingless-bottom is-border-top is-border--dashed vadTask-footer columns is-gapless">
        <div class="column is-narrow-widescreen">
          <button
            class="button is-fullwidth is-white is-small is-radiusless is-size-7"
            :disabled="cardLoading"
            @click="updateRelation('refused')">
            <span class="icon is-small"><i class="fas fa-stop-circle"></i></span>
            <span class="is-uppercase">Refuser l'invitation</span>
          </button>
        </div>
        <div class="column is-narrow-widescreen">
          <button
            @click="updateRelation('accepted')"
            class="button is-fullwidth is-primary is-small is-radiusless is-size-7"
            :disabled="cardLoading">
            <span class="icon is-small"><i class="fas fa-check"></i></span>
            <span class="is-uppercase">Accepter invitation</span>
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { DefaultValues } from '@/mixins'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'InvitationCard',
  mixins: [DefaultValues],
  props: {
    invitation: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      cardLoading: false
    }
  },
  computed: {
    ...mapGetters(['isPromoteur']),
    ...mapState(['currentUser']),
    avatar () {
      let avatar = {
        icon: 'fal fa-paper-plane'
      }
      if (this.invitation.status === 'refused') {
        avatar.background = 'has-background-danger'
      } else {
        avatar.background = 'has-background-warning'
      }
      return avatar
    }
  },
  methods: {
    canceledInvitation () {
      if (this.invitation.type === 'invitation') {
        this.$emit('canceledInvitation', this.invitation.pk)
      } else {
        this.$emit('deleteRelation', this.invitation.pk)
      }
    },
    updateRelation (status) {
      this.$emit('updateRelationStatus', this.invitation.pk, status)
    },
    showMessage (text) {
      return this.$swal({
        title: 'Message',
        html: text,
        showConfirmButton: false,
        showCancelButton: false
      })
    }
  }
}
</script>
